export const generateTemplateField = () => {
  
}
